import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import SecondaryLineLoader from '../../../components/Utils/SecondaryLineLoader';

const useStyles = makeStyles(theme => ({
  root: {
    margin: 'auto',
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
  result: {
    border: '1px solid #DFE3E8;',
    boxShadow: '0 0 0 0 rgba(255, 105, 135, .3)',
    backgroundColor: '#ffffff',
    margin: '0px 0px 0px 5px'
  },
  moreButton: {
    width: '100%',
    margin: '5px 0px 0px 5px',
  },
  padding: '0px',
}));

function MemberSubmissionResults(props) {
  const classes = useStyles();
  if (!props.results) {
    return null;
  }
  return (
      <React.Fragment>
        {props.loading ? <div className={classes.root}>
              <SecondaryLineLoader/>
            </div>
            : null}

        <List dense component='nav' role='list'>
          {props.results.map((value, index) => {
            return (
                <div
                    key={index}
                >
                  <ListItem
                      className={classes.result}
                      button
                      key={value.companyId}
                      role='listitem'
                      component={'li'}
                      id={'memberSubmissionResult-' + index}
                      onClick={() => props.setCurrent(value.companyId, value.type, value.year, value.status)}
                  >
                    <Grid container spacing={2} >
                      <Grid
                        item xs={6}
                      >

                        <ListItemText
                            primary={value.companyName}
                            secondary={'Company Name'}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <ListItemText
                            primary={value.type}
                            secondary='TYPE'
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <ListItemText
                            primary={value.submissionDate}
                            secondary='SUBMISSION DATE'
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <ListItemText
                            primary={value.status}
                            secondary='STATUS'
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <ListItemText
                            primary={value.submittedBy}
                            secondary='SUBMITTED BY'
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                </div>
            );
          })}
          {props.hasNextPage ?
              <Button
                  className={classes.moreButton}
                  color={'secondary'}
                  variant={'contained'}
                  onClick={props.loadMore}
              >
                Load More
              </Button> : null}
        </List>
      </React.Fragment>
  );
}

export default MemberSubmissionResults;
